import { getTwaStatus, storeTwaStatus } from 'store/sessionTwa';
const TWA_PROTOCOL = 'android-app:';
const packageName = process.env.REACT_APP_APPLICATION_ID;

/**
 * This method should run on every page load. `packageName` corresponds to the ID
 * of the app on the Play Store. This is important to differentiate from the page
 * being opened from a Custom Tab, for instance.
 */
export const isTrustedWebActivity = () => {
  const sessionStorageStatus = getTwaStatus();
  // alert(sessionStorageStatus);
  if (sessionStorageStatus === 'true') {
    return true;
  }

  const referrer = document.referrer.trim();
  if (referrer.length === 0) {
    return false;
  }

  const referrerUrl = new URL(referrer);
  // alert(referrerUrl.protocol);
  if (
    referrerUrl.protocol === TWA_PROTOCOL &&
    referrerUrl.hostname === packageName
  ) {
    storeTwaStatus('true');
    return true;
  }

  return false;
};
